/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Typography,
  Box,
  Container,
  Grid,
  Card,
  Switch,
  CardHeader,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Stack,
} from '@mui/material';
import ReactApexChart from 'react-apexcharts';
import { remove } from 'lodash';
import ApexCharts from 'apexcharts';
import axiosInstance from '../../utils/axiosInstance';
import {
  GPU_OPTIONS,
  MEMORY_OPTIONS,
  CPU_OPTIONS,
  FILE_OPTIONS,
  EMC_FREQUENCY_OPTIONS,
  ENC_DEC_FREQUENCY_OPTIONS,
} from './debug-graph-options/debugGraphOptions';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <Box role="tabpanel" sx={{ display: value === index ? 'inline' : 'none' }}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function SystemStatsTab() {
  const hostList = useSelector((state) => state.app.hostList);
  const [vstDevice, setVstDevice] = useState(hostList.length > 0 ? hostList[0] : null);
  const vstDeviceRef = useRef(hostList.length > 0 ? hostList[0] : null);
  const gpuGraphData = useRef([]);
  const cpuGraphData = useRef([]);
  const memoryGraphData = useRef([]);
  const openFilesGraphData = useRef([]);
  const dmaBufGraphData = useRef([]);
  const iovmmGraphData = useRef([]);
  const emcFrequencyGraphData = useRef([]);
  const encDecFrequencyGraphData = useRef([]);
  const [refreshGraphs, setRefreshGraphs] = useState(false);
  const [isTegraStats, setIsTegraStats] = useState(false);
  const [lastCpuData, setLastCpuData] = useState('');
  const [lastGpuData, setLastGpuData] = useState('');
  const [lastMemoryData, setLastMemoryData] = useState('');
  const [lastFileCount, setLastFileCount] = useState('');
  const [lastEmcData, setLastEmcData] = useState('');
  const [lastEncDecData, setLastEncDecData] = useState('');
  const [gpuIndex, setGpuIndex] = useState(null);
  const [gpuName, setGpuName] = useState(null);
  const intervalRef = useRef();

  useEffect(
    () => () => {
      console.log('stop refresh');
      clearInterval(intervalRef.current);
    },
    []
  );

  const handleVstDeviceChange = (e) => {
    cleanup();
    setVstDevice(e.target.value);
    vstDeviceRef.current = e.target.value;
  };

  const fetchData = () => {
    const currDate = new Date().getTime();
    axiosInstance
      .get(`${window.location.protocol}//${vstDeviceRef.current}/api/v1/sensor/debug/system/stats`)
      // eslint-disable-next-line no-unused-vars
      .then((response) => {
        const { data } = response;
        console.log('system stats: ', data);
        if (data) {
          if (Object.prototype.hasOwnProperty.call(data, 'cpu_usage')) {
            let f = 0;
            for (let i = 0; i < cpuGraphData.current.length; i += 1) {
              if (cpuGraphData.current[i].name === 'CPU usage') {
                f = 1;
                setLastCpuData(`${Number(data.cpu_usage)}%`);
                cpuGraphData.current[i].data.push([currDate, Number(data.cpu_usage)]);
              }
            }
            if (f === 0) {
              setLastCpuData(`${Number(data.cpu_usage)}%`);
              cpuGraphData.current.push({
                name: 'CPU usage',
                data: [[currDate, Number(data.cpu_usage)]],
              });
            }
          }
          let lastGpuUsageStr = '';
          if (Object.prototype.hasOwnProperty.call(data, 'dec_usage')) {
            let f = 0;
            for (let i = 0; i < gpuGraphData.current.length; i += 1) {
              if (gpuGraphData.current[i].name === 'decoder usage') {
                f = 1;
                lastGpuUsageStr += `Decoder: ${Number(data.dec_usage)}%`;
                gpuGraphData.current[i].data.push([currDate, Number(data.dec_usage)]);
              }
            }
            if (f === 0) {
              lastGpuUsageStr += `Decoder: ${Number(data.dec_usage)}%`;
              gpuGraphData.current.push({
                name: 'decoder usage',
                data: [[currDate, Number(data.dec_usage)]],
              });
            }
          }
          if (Object.prototype.hasOwnProperty.call(data, 'enc_usage')) {
            let f = 0;
            for (let i = 0; i < gpuGraphData.current.length; i += 1) {
              if (gpuGraphData.current[i].name === 'encoder usage') {
                f = 1;
                lastGpuUsageStr += `, Encoder: ${Number(data.enc_usage)}%`;
                gpuGraphData.current[i].data.push([currDate, Number(data.enc_usage)]);
              }
            }
            if (f === 0) {
              lastGpuUsageStr += `, Encoder: ${Number(data.enc_usage)}%`;
              gpuGraphData.current.push({
                name: 'encoder usage',
                data: [[currDate, Number(data.enc_usage)]],
              });
            }
          }
          if (Object.prototype.hasOwnProperty.call(data, 'gpu_usage')) {
            let f = 0;
            for (let i = 0; i < gpuGraphData.current.length; i += 1) {
              if (gpuGraphData.current[i].name === 'GPU usage') {
                f = 1;
                lastGpuUsageStr += `, GPU: ${Number(data.gpu_usage)}%`;
                gpuGraphData.current[i].data.push([currDate, Number(data.gpu_usage)]);
              }
            }
            if (f === 0) {
              lastGpuUsageStr += `, GPU: ${Number(data.gpu_usage)}%`;
              gpuGraphData.current.push({
                name: 'GPU usage',
                data: [[currDate, Number(data.gpu_usage)]],
              });
            }
          }
          setLastGpuData(lastGpuUsageStr);

          let memoryUsageStr = '';
          if (Object.prototype.hasOwnProperty.call(data, 'rss_MB')) {
            let f = 0;
            for (let i = 0; i < memoryGraphData.current.length; i += 1) {
              if (memoryGraphData.current[i].name === 'RSS') {
                f = 1;
                memoryUsageStr += `RSS: ${Number(data.rss_MB)}MB, `;
                memoryGraphData.current[i].data.push([currDate, Number(data.rss_MB)]);
              }
            }
            if (f === 0) {
              memoryUsageStr += `RSS: ${Number(data.rss_MB)}MB, `;
              memoryGraphData.current.push({
                name: 'RSS',
                data: [[currDate, Number(data.rss_MB)]],
              });
            }
          }
          if (Object.prototype.hasOwnProperty.call(data, 'system_memory_usage_MB')) {
            let f = 0;
            for (let i = 0; i < memoryGraphData.current.length; i += 1) {
              if (memoryGraphData.current[i].name === 'system memory') {
                f = 1;
                memoryUsageStr += `System memory: ${Number(data.system_memory_usage_MB)}MB, `;
                memoryGraphData.current[i].data.push([currDate, Number(data.system_memory_usage_MB)]);
              }
            }
            if (f === 0) {
              memoryUsageStr += `System memory: ${Number(data.system_memory_usage_MB)}MB, `;
              memoryGraphData.current.push({
                name: 'system memory',
                data: [[currDate, Number(data.system_memory_usage_MB)]],
              });
            }
          }
          if (Object.prototype.hasOwnProperty.call(data, 'gpu_name')) {
            setGpuName(data.gpu_name);
          }
          if (Object.prototype.hasOwnProperty.call(data, 'gpu_index')) {
            setGpuIndex(data.gpu_index);
          }
          if (Object.prototype.hasOwnProperty.call(data, 'total_gpu_mem_usage_MB')) {
            let f = 0;
            for (let i = 0; i < memoryGraphData.current.length; i += 1) {
              if (memoryGraphData.current[i].name === 'Total GPU memory usage') {
                f = 1;
                memoryUsageStr += `Total GPU memory: ${Number(data.total_gpu_mem_usage_MB)}MB, `;
                memoryGraphData.current[i].data.push([currDate, Number(data.total_gpu_mem_usage_MB)]);
              }
            }
            if (f === 0) {
              memoryUsageStr += `Total GPU memory: ${Number(data.total_gpu_mem_usage_MB)}MB, `;
              memoryGraphData.current.push({
                name: 'Total GPU memory usage',
                data: [[currDate, Number(data.total_gpu_mem_usage_MB)]],
              });
            }
          }
          if (Object.prototype.hasOwnProperty.call(data, 'vst_gpu_mem_usage_MB')) {
            let f = 0;
            for (let i = 0; i < memoryGraphData.current.length; i += 1) {
              if (memoryGraphData.current[i].name === 'VST GPU memory usage') {
                f = 1;
                memoryUsageStr += `VST GPU memory: ${Number(data.vst_gpu_mem_usage_MB)}MB, `;
                memoryGraphData.current[i].data.push([currDate, Number(data.vst_gpu_mem_usage_MB)]);
              }
            }
            if (f === 0) {
              memoryUsageStr += `VST GPU memory: ${Number(data.vst_gpu_mem_usage_MB)}MB, `;
              memoryGraphData.current.push({
                name: 'VST GPU memory usage',
                data: [[currDate, Number(data.vst_gpu_mem_usage_MB)]],
              });
            }
          }

          if (Object.prototype.hasOwnProperty.call(data, 'iovmm_MB')) {
            let f = 0;
            for (let i = 0; i < memoryGraphData.current.length; i += 1) {
              if (memoryGraphData.current[i].name === 'iovmm') {
                f = 1;
                memoryUsageStr += `iovmm: ${Number(data.iovmm_MB)}MB, `;
                memoryGraphData.current[i].data.push([currDate, Number(data.iovmm_MB)]);
              }
            }
            if (f === 0) {
              memoryUsageStr += `iovmm: ${Number(data.iovmm_MB)}MB, `;
              memoryGraphData.current.push({
                name: 'iovmm',
                data: [[currDate, Number(data.iovmm_MB)]],
              });
            }
          }
          if (Object.prototype.hasOwnProperty.call(data, 'total_iovmm_MB')) {
            let f = 0;
            for (let i = 0; i < memoryGraphData.current.length; i += 1) {
              if (memoryGraphData.current[i].name === 'total iovmm') {
                f = 1;
                memoryUsageStr += `Total iovmm: ${Number(data.total_iovmm_MB)}MB `;
                memoryGraphData.current[i].data.push([currDate, Number(data.total_iovmm_MB)]);
              }
            }
            if (f === 0) {
              memoryUsageStr += `Total iovmm: ${Number(data.total_iovmm_MB)}MB `;
              memoryGraphData.current.push({
                name: 'total iovmm',
                data: [[currDate, Number(data.total_iovmm_MB)]],
              });
            }
          }
          setLastMemoryData(memoryUsageStr);

          let openFilesStr = '';
          if (Object.prototype.hasOwnProperty.call(data, 'open_files_count')) {
            let f = 0;
            for (let i = 0; i < openFilesGraphData.current.length; i += 1) {
              if (openFilesGraphData.current[i].name === 'open files count') {
                f = 1;
                openFilesStr += `Open files count: ${Number(data.open_files_count)}`;
                openFilesGraphData.current[i].data.push([currDate, Number(data.open_files_count)]);
              }
            }
            if (f === 0) {
              openFilesStr += `Open files count: ${Number(data.open_files_count)}`;
              openFilesGraphData.current.push({
                name: 'open files count',
                data: [[currDate, Number(data.open_files_count)]],
              });
            }
          }

          // Tegrastats
          if (Object.prototype.hasOwnProperty.call(data, 'tegrastats')) {
            setIsTegraStats(true);
            if (Object.prototype.hasOwnProperty.call(data.tegrastats, 'CPU')) {
              const cpuUsageStr = data.tegrastats.CPU;
              const cpuUsageDirtyArr = cpuUsageStr.split(',');
              const cpuUsageArr = remove(cpuUsageDirtyArr, (n) => n !== 'off');
              let usage = 0;
              let freq = 0;
              for (let i = 0; i < cpuUsageArr.length; i += 1) {
                const arr = cpuUsageArr[i].split('%@');
                usage += Number(arr[0]);
                freq = Number(arr[1]);
              }
              usage /= cpuUsageArr.length;
              let f = 0;
              for (let i = 0; i < cpuGraphData.current.length; i += 1) {
                if (cpuGraphData.current[i].name === 'CPU usage') {
                  f = 1;
                  setLastCpuData(`${Number(usage)}% at ${freq}MHz`);
                  cpuGraphData.current[i].data.push([currDate, Number(usage)]);
                }
              }
              if (f === 0) {
                setLastCpuData(`${Number(usage)}% at ${freq}MHz`);
                cpuGraphData.current.push({
                  name: 'CPU usage',
                  data: [[currDate, Number(usage)]],
                });
              }
            }
            if (Object.prototype.hasOwnProperty.call(data, 'dma_buf_count')) {
              let f = 0;
              for (let i = 0; i < openFilesGraphData.current.length; i += 1) {
                if (openFilesGraphData.current[i].name === 'dma buf count') {
                  f = 1;
                  openFilesStr += `, DMA buf count: ${Number(data.dma_buf_count)}`;
                  openFilesGraphData.current[i].data.push([currDate, Number(data.dma_buf_count)]);
                }
              }
              if (f === 0) {
                openFilesStr += `, DMA buf count: ${Number(data.dma_buf_count)}`;
                openFilesGraphData.current.push({
                  name: 'dma buf count',
                  data: [[currDate, Number(data.dma_buf_count)]],
                });
              }
            }
            let lastEmcStr = '';
            if (Object.prototype.hasOwnProperty.call(data.tegrastats, 'EMC_FREQ_MHz')) {
              const arr = data.tegrastats.EMC_FREQ_MHz.split('%@');
              const val = arr[0];
              const freq = arr[1];
              let f = 0;
              for (let i = 0; i < emcFrequencyGraphData.current.length; i += 1) {
                if (emcFrequencyGraphData.current[i].name === 'EMC Frequency') {
                  f = 1;
                  lastEmcStr += `EMC Usage: ${Number(val)}% at ${freq}MHz`;
                  emcFrequencyGraphData.current[i].data.push([currDate, Number(val)]);
                }
              }
              if (f === 0) {
                lastEmcStr += `EMC Usage: ${Number(val)}% at ${freq}MHz`;
                emcFrequencyGraphData.current.push({
                  name: 'EMC Frequency',
                  data: [[currDate, Number(val)]],
                });
              }
            }
            setLastEmcData(lastEmcStr);

            let lastEncDecStr = '';
            if (Object.prototype.hasOwnProperty.call(data.tegrastats, 'NVDEC_MHz')) {
              const arr = data.tegrastats.NVDEC_MHz.split('%@');
              const val = arr[0];
              let f = 0;
              for (let i = 0; i < encDecFrequencyGraphData.current.length; i += 1) {
                if (encDecFrequencyGraphData.current[i].name === 'NVDEC Frequency') {
                  f = 1;
                  lastEncDecStr += `NVDEC: ${Number(val)}MHz`;
                  console.log('lastEncDecStr', lastEncDecStr);
                  encDecFrequencyGraphData.current[i].data.push([currDate, Number(val)]);
                }
              }
              if (f === 0) {
                lastEncDecStr += `NVDEC: ${Number(val)}MHz`;
                encDecFrequencyGraphData.current.push({
                  name: 'NVDEC Frequency',
                  data: [[currDate, Number(val)]],
                });
              }
            }
            if (Object.prototype.hasOwnProperty.call(data.tegrastats, 'NVENC_MHz')) {
              const arr = data.tegrastats.NVENC_MHz.split('%@');
              const val = arr[0];
              let f = 0;
              for (let i = 0; i < encDecFrequencyGraphData.current.length; i += 1) {
                if (encDecFrequencyGraphData.current[i].name === 'NVENC Frequency') {
                  lastEncDecStr += `, NVENC: ${Number(val)}MHz`;
                  f = 1;
                  encDecFrequencyGraphData.current[i].data.push([currDate, Number(val)]);
                }
              }
              if (f === 0) {
                lastEncDecStr += `, NVENC: ${Number(val)}MHz`;
                encDecFrequencyGraphData.current.push({
                  name: 'NVENC Frequency',
                  data: [[currDate, Number(val)]],
                });
              }
            }
            if (Object.prototype.hasOwnProperty.call(data.tegrastats, 'NVDEC1_MHz')) {
              const arr = data.tegrastats.NVDEC1_MHz.split('%@');
              const val = arr[0];
              let f = 0;
              for (let i = 0; i < encDecFrequencyGraphData.current.length; i += 1) {
                if (encDecFrequencyGraphData.current[i].name === 'NVDEC1 Frequency') {
                  f = 1;
                  lastEncDecStr += `, NVDEC1: ${Number(val)}MHz`;
                  encDecFrequencyGraphData.current[i].data.push([currDate, Number(val)]);
                }
              }
              if (f === 0) {
                lastEncDecStr += `, NVDEC1: ${Number(val)}MHz`;
                encDecFrequencyGraphData.current.push({
                  name: 'NVDEC1 Frequency',
                  data: [[currDate, Number(val)]],
                });
              }
            }
            if (Object.prototype.hasOwnProperty.call(data.tegrastats, 'NVENC1_MHz')) {
              const arr = data.tegrastats.NVENC1_MHz.split('%@');
              const val = arr[0];
              let f = 0;
              for (let i = 0; i < encDecFrequencyGraphData.current.length; i += 1) {
                if (encDecFrequencyGraphData.current[i].name === 'NVENC1 Frequency') {
                  f = 1;
                  lastEncDecStr += `NVENC1: ${Number(val)}MHz`;
                  encDecFrequencyGraphData.current[i].data.push([currDate, Number(val)]);
                }
              }
              if (f === 0) {
                lastEncDecStr += `NVENC1: ${Number(val)}MHz`;
                encDecFrequencyGraphData.current.push({
                  name: 'NVENC1 Frequency',
                  data: [[currDate, Number(val)]],
                });
              }
            }
            setLastEncDecData(lastEncDecStr);
          }
          setLastFileCount(openFilesStr);

          ApexCharts.exec('cpuGraph', 'updateOptions', {
            series: cpuGraphData.current,
          });
          ApexCharts.exec('gpuGraph', 'updateOptions', {
            series: gpuGraphData.current,
          });
          ApexCharts.exec('memoryGraph', 'updateOptions', {
            series: memoryGraphData.current,
          });
          ApexCharts.exec('openFilesGraph', 'updateOptions', {
            series: openFilesGraphData.current,
          });
          ApexCharts.exec('emcFrequencyGraph', 'updateOptions', {
            series: emcFrequencyGraphData.current,
          });
          ApexCharts.exec('encDecFrequencyGraph', 'updateOptions', {
            series: encDecFrequencyGraphData.current,
          });
        }
      })
      .catch((e) => {
        console.log('Failed to fetch system stats', e);
      });
  };

  const dataFetcher = () => {
    intervalRef.current = setInterval(() => {
      fetchData();
    }, 5000);
  };

  const cleanup = () => {
    /**
     * clean arrays
     */
    cpuGraphData.current = [];
    gpuGraphData.current = [];
    memoryGraphData.current = [];
    openFilesGraphData.current = [];
    dmaBufGraphData.current = [];
    iovmmGraphData.current = [];
    emcFrequencyGraphData.current = [];
    encDecFrequencyGraphData.current = [];
    ApexCharts.exec('cpuGraph', 'updateOptions', {
      series: cpuGraphData.current,
    });
    ApexCharts.exec('gpuGraph', 'updateOptions', {
      series: gpuGraphData.current,
    });
    ApexCharts.exec('memoryGraph', 'updateOptions', {
      series: memoryGraphData.current,
    });
    ApexCharts.exec('openFilesGraph', 'updateOptions', {
      series: openFilesGraphData.current,
    });
    ApexCharts.exec('dmaBufCount', 'updateOptions', {
      series: dmaBufGraphData.current,
    });
    ApexCharts.exec('iovmmGraph', 'updateOptions', {
      series: iovmmGraphData.current,
    });
    ApexCharts.exec('emcFrequencyGraph', 'updateOptions', {
      series: emcFrequencyGraphData.current,
    });
    ApexCharts.exec('encDecFrequencyGraph', 'updateOptions', {
      series: encDecFrequencyGraphData.current,
    });
  };

  const handleRefreshGraphs = () => {
    if (!refreshGraphs) {
      dataFetcher();
    } else {
      console.log('stop refresh');
      clearInterval(intervalRef.current);
      cleanup();
    }
    setRefreshGraphs(!refreshGraphs);
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" sx={{ mb: 5 }}>
        System stats
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12}>
          <Box sx={{ p: 3 }}>
            <Stack direction="row" alignItems="center">
              <Typography variant="body2" sx={{ ml: 1 }}>
                Off
              </Typography>
              <Switch checked={refreshGraphs} onChange={handleRefreshGraphs} />
              <Typography variant="body2" sx={{ ml: 1 }}>
                On
              </Typography>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <CardHeader title={`${window.adaptorType} devices`} subheader={`Select ${window.adaptorType} device`} />
            <Box sx={{ p: 3, pb: 1 }} dir="ltr">
              <FormControl>
                <RadioGroup row name="vst-device-radio-button" value={vstDevice} onChange={handleVstDeviceChange}>
                  {hostList.map((host) => (
                    <FormControlLabel
                      value={host}
                      control={<Radio />}
                      label={`${window.adaptorType} ${host}`}
                      key={host}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ p: 3 }} dir="ltr">
              <Typography variant="body2" sx={{ ml: 1 }}>
                {lastCpuData}
              </Typography>
              <ReactApexChart type="line" height={350} series={[]} options={CPU_OPTIONS} />
            </Box>
          </Card>
        </Grid>
        {!isTegraStats && (
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <Box sx={{ p: 3 }} dir="ltr">
                {gpuName != null && gpuIndex != null && (
                  <Typography
                    variant="body2"
                    sx={{ ml: 1 }}
                  >{`GPU name: ${gpuName}, GPU index: ${gpuIndex}`}</Typography>
                )}
                <Typography variant="body2" sx={{ ml: 1 }}>
                  {lastGpuData}
                </Typography>
                <ReactApexChart type="line" height={350} series={[]} options={GPU_OPTIONS} />
              </Box>
            </Card>
          </Grid>
        )}
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ m: 3 }} dir="ltr">
              <Typography variant="body2" sx={{ ml: 1 }}>
                {lastMemoryData}
              </Typography>
              <ReactApexChart type="area" height={350} series={[]} options={MEMORY_OPTIONS} />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Card>
            <Box sx={{ m: 3 }} dir="ltr">
              <Typography variant="body2" sx={{ ml: 1 }}>
                {lastFileCount}
              </Typography>
              <ReactApexChart type="line" height={350} series={[]} options={FILE_OPTIONS} />
            </Box>
          </Card>
        </Grid>
        {isTegraStats && (
          <>
            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <Box sx={{ m: 3 }} dir="ltr">
                  <Typography variant="body2" sx={{ ml: 1 }}>
                    {lastEmcData}
                  </Typography>
                  <ReactApexChart type="line" height={350} series={[]} options={EMC_FREQUENCY_OPTIONS} />
                </Box>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <Box sx={{ m: 3 }} dir="ltr">
                  <Typography variant="body2" sx={{ ml: 1 }}>
                    {lastEncDecData}
                  </Typography>
                  <ReactApexChart type="line" height={350} series={[]} options={ENC_DEC_FREQUENCY_OPTIONS} />
                </Box>
              </Card>
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
}
